import { SnotifyPosition } from 'vue-snotify';
var ToastConfig = /** @class */ (function () {
    function ToastConfig() {
    }
    ToastConfig.ToastDefaultStyle = 'vue-notify--material';
    ToastConfig.ToastGlobalConfig = {
        newOnTop: true,
        maxOnScreen: 5,
        maxAtPosition: 5,
    };
    ToastConfig.ToastDefaultConfig = {
        timeout: 5000,
        position: SnotifyPosition.rightBottom,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        titleMaxLength: 31,
        bodyMaxLength: 127,
        backdrop: -1,
    };
    return ToastConfig;
}());
export { ToastConfig };
//# sourceMappingURL=ToastConfig.js.map